import { createDecorator } from "../../instantiation/common/registry.js";
import { Event } from "../../../base/common/events.js";
import { IKeyboardEvent } from "../../../base/browser/keyboardEvent.js";

export type KeyCode = ({} & string); // e.g., "KeyA", "ArrowUp", "Digit1", etc.
export type ModifierKey = "Shift" | "ShiftLeft" | "Control" | "ControlLeft" | "Alt" | "AltLeft" | "Meta" | "MetaLeft";

export const isModifierKey = (key: string): key is ModifierKey => {
    switch(key) {
        case "Shift":
        case "Control":
        case "Alt":
        case "Meta":
        case "ShiftLeft":
        case "ControlLeft":
        case "AltLeft":
        case "MetaLeft":
            return true;
    }
    return false;
}

export const IKeyboardService = createDecorator<IKeyboardService>('keyboardService');

export interface IKeyboardService {
    isKeyPressed(key: KeyCode | ModifierKey): boolean;

    readonly onKeyDown: Event<IKeyboardEvent>;
    readonly onKeyUp: Event<IKeyboardEvent>;
    readonly onKeyPress: Event<IKeyboardEvent>;
}

